import { LoanProductCategory } from '@ilg-totallymoney/types'

import { categories } from '@config/categories'

export const getCategoryPathForId = (categoryId: LoanProductCategory) => {
    return categories[categoryId]?.path
}
